import React, { useState } from 'react';
import {CarregaItensDevolucao} from './carrega-itens-devolucao';

const ItensDevolucao = (props) => {
    const {vendaSelecionada, onChangeCredito, onChange} = props;
   // const [value, setValue] = useState();

    const onChangeThis = (itens) => {
     //   setValue(itens);
        onChangeCredito && onChangeCredito(itens)
        onChange && onChange(itens)
    }

    if(vendaSelecionada !== null){
        return <CarregaItensDevolucao 
                onChangeCredito={onChangeThis}
                vendaSelecionada={vendaSelecionada}></CarregaItensDevolucao>;
    } 

    return <></>;
}

export {ItensDevolucao};